import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteDirectoryProtection } from "../openapi/api-client.ts";
import { operations } from "../openapi/generated-types.ts";

export const useDeleteDirectoryProtection = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: operations["directoryprotection.delete"]["requestBody"]["content"]["application/json"],
    ) => {
      return deleteDirectoryProtection(body, {
        path: { projectId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["directoryProtections", { projectId }],
        }),
      ]);
    },
  });
};
